export const parseMediaURL = (url?: string) => {
  return url ? (url.includes("?") ? url.split("?")[0] : url) : "";
};
